import gql from "graphql-tag";

export default gql`
  query {
    programIDs(last: 1) {
      programID
    }
  }
`;
